import { styled, typography } from '@pulse-web-ui/theme';

export const DescriptionContainer = styled.div`
  margin-top: 8px;
`;

export const Description = styled.h3<{
  $center?: boolean;
  $marginBottom?: number;
}>`
  ${typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: ${({ $center }) => ($center ? 'center' : 'inherit')};
  line-height: 24px;
  margin: 0;
`;
